var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-tabs",
            {
              attrs: { value: _vm.queryParamsTradeStatus, type: "card" },
              on: { "tab-click": _vm.handleTabClick },
            },
            [
              _c("el-tab-pane", {
                key: "one",
                attrs: { label: _vm.$t("billingPage.CAMPARE"), name: "one" },
              }),
              _c("el-tab-pane", {
                key: "two",
                attrs: { label: _vm.$t("billingPage.DBFILE"), name: "two" },
              }),
              _c("el-tab-pane", {
                key: "thr",
                attrs: { label: _vm.$t("billingPage.HISTORY"), name: "thr" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("shipping-campare", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.queryParamsTradeStatus == "one",
            expression: "queryParamsTradeStatus=='one'",
          },
        ],
        attrs: { "data-info": _vm.dataInfo },
        on: {
          compare: _vm._compareShippingCharge,
          gotoCharge: _vm._gotoCharge,
          importToDb: _vm._importToDb,
        },
      }),
      _c("db-Saved-File-History", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.queryParamsTradeStatus == "two",
            expression: "queryParamsTradeStatus=='two'",
          },
        ],
      }),
      _c("surcharged-File-History", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.queryParamsTradeStatus == "thr",
            expression: "queryParamsTradeStatus=='thr'",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }